if (!customElements.get('enhanceify-cnc-location-widget')) {
  class EnhanceifyCncLocationWidget extends HTMLElement {
    constructor() {
      super();

      this.setCurrentLocation = this.querySelector('.set-location');
      this.variantStock = this.querySelector('.variant-stock');
      this.changeLocationTrigger = this.querySelector('.cnc-current-location-widget');
      this.cncCurrentLocation = this.querySelector('.cnc-current-location');

      const closestForm = this.closest('.product__info-wrapper');
      const variantIdInput = closestForm.querySelector('.product-variant-id');
      const customersClosestLocationId = this.querySelector('#closestLocation');
      const onlineLocationId = this.querySelector('#onlineLocation');

      this.variant_id = variantIdInput.value;

      const pswCnc = this.querySelector('.psw-cnc');
      const pswShipping = this.querySelector('.psw-shipping');
      const cncMessages = this.querySelector('.cnc-product-availability');
      const onlineStockMessage = this.querySelector('.psw-shipping p');

      const variant_id = this.variant_id;
      const changeLocationContainer = this.querySelector('.cnc-choose-location');
      const customer_id = this.querySelector('#customerId').value;

      const postcodeInput = this.querySelector('#customerPostCode');
      const stateInput = this.querySelector('#closestState');

      const postcode = postcodeInput.value || localStorage.getItem('pickup_location_postcode');
      const location_id = customersClosestLocationId.value || localStorage.getItem('pickup_location_id');
      const delivery_choice = localStorage.getItem('preferred_delivery_method');
      // const state = stateInput.value || localStorage.getItem('pickup_location_state');

      if (delivery_choice) {
        if (delivery_choice === 'pickup') {
          pswShipping.classList.remove('active');
          pswCnc.classList.add('active');
        } else {
          pswShipping.classList.add('active');
          pswCnc.classList.remove('active');
        }
      }

      pswShipping.addEventListener('click', function () {
        if (!pswShipping.classList.contains('oos')) {
          pswShipping.classList.toggle('active');
          pswCnc.classList.toggle('active');
          localStorage.setItem('preferred_delivery_method', 'ship');
        }
      });

      pswCnc.addEventListener('click', function () {
        if (!pswCnc.classList.contains('oos')) {
          pswShipping.classList.toggle('active');
          pswCnc.classList.toggle('active');
          localStorage.setItem('preferred_delivery_method', 'pickup');
        }
      });

      this.changeLocationTrigger.addEventListener('click', function () {
        changeLocationContainer.classList.toggle('active');
      });

      variantIdInput.addEventListener('change', function () {
        console.log('this.variantIdInput customersClosestLocationId', customersClosestLocationId.value);
        console.log('this.variantIdInput postcode', postcodeInput.value);

        const getUpdatedProductInventoryData = {
          variant_id: variantIdInput.value,
          location_id: customersClosestLocationId.value,
          online_location_id: onlineLocationId.value,
          postcode: postcodeInput.value,
        };
        getProductInventory(getUpdatedProductInventoryData);
      });

      const getProductInventory = (data) => {
        this.classList.add('loading');
        fetch(`${window.enhanceify.appUrl}/getProductLocationInventory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status === 200) {
              if (data.online_stock === '0' && data.product_location?.inventory_levels.length === 0) {
                onlineStockMessage.textContent = 'Out of stock';
              } else {
                onlineStockMessage.textContent = pswShipping.querySelector('.psw-ship-msg').value;
              }

              if (data.matched_location !== null) {
                this.cncCurrentLocation.textContent = data.matched_location.name;
                customersClosestLocationId.value = data.matched_location.id;
                if (data.matched_location.id) {
                  localStorage.setItem('pickup_location_id', data.matched_location.id);
                  localStorage.setItem('pickup_location_postcode', data.matched_location.zip);
                  localStorage.setItem('pickup_location_state', data.matched_location.province);
                }

                let pickup_time = 24;

                if (data.matched_location.pickup_time === 'TWELVE_HOURS') {
                  pickup_time = 12;
                }

                if (
                  data.product_location.inventory_levels.length > 0 &&
                  data.product_location.inventory_levels[0].available > 0
                ) {
                  this.variantStock.innerHTML = `${data.product_location.inventory_levels[0].available} in stock <br/> Ready in ${pickup_time} hours`;
                  pswCnc.classList.remove('oos');
                } else {
                  this.variantStock.textContent = 'Not available';
                  pswCnc.classList.add('oos');
                }
              } else if (
                data.product_location.inventory_levels.length > 0 &&
                data.product_location.inventory_levels[0].available > 1
              ) {
                console.log('data.product_location.inventory_levels.length > 0 &&');

                variantStock.textContent = `${data.product_location.inventory_levels[0].available} in stock`;
                pswCnc.classList.remove('oos');
              } else {
                console.log('else');

                this.variantStock.textContent = 'Not available';
                pswCnc.classList.add('oos');
              }
            } else {
              this.querySelector('.cnc-cl-message').textContent = '';
              this.variantStock.textContent = 'Try updating your postcode.';
              pswCnc.classList.add('oos');
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          })
          .finally(() => {
            this.classList.remove('loading');
          });
      };

      if (postcode == '' || postcode === null) {
        // ipinfo is a free API
        fetch('https://ipinfo.io/json')
          .then((response) => response.json())
          .then((currentIp) => {
            console.log(currentIp.ip);
            fetch(`https://ipapi.co/${currentIp.ip}/json/`)
              .then(function (response) {
                response.json().then((currentLocationData) => {
                  const getProductInventoryData = {
                    variant_id: variant_id,
                    location_id: null,
                    online_location_id: onlineLocationId.value,
                    postcode: currentLocationData.postal,
                    state: currentLocationData.region,
                  };
                  getProductInventory(getProductInventoryData);
                });
              })
              .catch(function (error) {
                console.log(error);
              });
          })
          .catch((error) => {
            console.error('Error fetching IP address:', error);
          });
      } else {
        const getProductInventoryData = {
          variant_id: this.variant_id,
          location_id: location_id,
          online_location_id: onlineLocationId.value,
          postcode: postcode,
        };

        getProductInventory(getProductInventoryData);
      }

      const setCustomerLocation = (data) => {
        fetch(`${window.enhanceify.appUrl}/updateCustomersClosestStore`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log('setCustomerLocation Success:', data);
            if (data.matched_location.id) {
              this.cncCurrentLocation.textContent = data.matched_location.name;
              customersClosestLocationId.value = data.matched_location.id;
              localStorage.setItem('pickup_location_id', data.matched_location.id);
              localStorage.setItem('pickup_location_postcode', data.matched_location.zip);
              localStorage.setItem('pickup_location_state', data.matched_location.province);
            }

            const product_id = document.querySelector('#variantId').value;

            if (data.matched_location.id) {
              const dataForProductInventory = {
                variant_id: product_id,
                location_id: data.matched_location.id,
                online_location_id: onlineLocationId.value,
              };

              getProductInventory(dataForProductInventory);
            } else {
              cncMessages.textContent = 'No stores found. Please click below to see available stores.';
              cncMessages.style.display = 'block';
            }
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      };

      this.setCurrentLocation.addEventListener('click', function () {
        cncMessages.textContent = '';
        cncMessages.style.display = 'none';

        const setCustomerLocationData = {
          customer_id: customer_id,
          postcode: postcodeInput.value,
        };

        setCustomerLocation(setCustomerLocationData);
      });
    }
  }

  customElements.define('enhanceify-cnc-location-widget', EnhanceifyCncLocationWidget);
}
